import { takeEvery } from 'redux-saga/effects';

import * as actions from 'store/modules/messagesPage';

import { deleteNotification } from './utils';

export default function* listenDeleteNotification() {
  yield takeEvery(actions.deleteNotification.toString(), deleteNotification);
}
